import Main from '@/components/main'
import parentView from '@/components/parent-view'

const tmallAfterSaleAccess = (access, user = {}) => access.indexOf('0') >= 0 || Number(user.is_tmall) === 1

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面不会缓存
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

export default [
  {
    path: '/',
    name: '_home',
    redirect: '/home',
    meta: { hide: true, title: '首页' },
    component: Main,
    children: [
      {
        path: '/home',
        name: 'home',
        meta: { title: '首页', notCache: true, icon: 'md-home' },
        component: () => import('@/view/home')
      }
    ]
  },
  {
    path: '/user_center',
    name: '_user_center',
    meta: { hideInMenu: true },
    component: Main,
    children: [
      {
        path: '/user_center',
        name: 'user_center',
        meta: { title: '个人中心', hide: true },
        component: () => import('@/view/user_center')
      }
    ]
  },
  {
    path: '/machine',
    redirect: '/machine/list',
    name: 'machine',
    meta: { title: '设备一览', icon: 'md-print' },
    component: Main,
    children: [
      {
        path: '/machine',
        name: 'machine-list',
        meta: { title: '设备列表', icon: 'md-list' },
        component: () => import('@/view/machine/list')
      },
      {
        path: '/machine-type',
        name: 'machine-type',
        meta: { access: ['0'], title: '设备型号', icon: 'md-keypad' },
        component: () => import('@/view/machine/type')
      },
      {
        path: '/machine-brand',
        name: 'machine-brand',
        meta: { access: ['0'], title: '设备品牌', icon: 'md-ribbon' },
        component: () => import('@/view/machine/brand')
      },
      {
        path: '/machine-add',
        name: 'machine-add',
        meta: { hideInMenu: true, title: '新增设备', icon: 'md-list' },
        component: () => import('@/view/machine/edit')
      },
      {
        path: '/machine-dispense/:id',
        name: 'machine-dispense',
        meta: { hideInMenu: true, title: '设备分账', icon: 'md-list' },
        component: () => import('@/view/machine/dispense')
      },
      {
        path: '/machine-edit/:id',
        name: 'machine-edit',
        meta: { hideInMenu: true, title: '设备编辑', icon: 'md-list' },
        component: () => import('@/view/machine/edit')
      },
      {
        path: '/charge',
        name: 'charge-list',
        meta: { title: '计费方案', icon: 'logo-yen' },
        component: () => import('@/view/charge/list')
      },
      {
        path: '/charge-add',
        name: 'charge-add',
        meta: { hideInMenu: true, title: '计费方案新增', icon: 'logo-yen' },
        component: () => import('@/view/charge/edit')
      },
      {
        path: '/charge-edit/:id',
        name: 'charge-edit',
        meta: { hideInMenu: true, title: '计费方案修改', icon: 'logo-yen' },
        component: () => import('@/view/charge/edit')
      },
      {
        path: '/site',
        name: 'site-list',
        meta: { title: '设备站点', icon: 'logo-skype' },
        component: () => import('@/view/site/list')
      },
      {
        path: '/scene',
        name: 'machine-scene',
        meta: { title: '设备场景', icon: 'md-compass', access: ['0'] },
        component: () => import('@/view/scene')
      },
      {
        path: '/repair',
        name: 'repair-list',
        meta: { title: '维护人员', icon: 'md-person' },
        component: () => import('@/view/repair/list')
      }
    ]
  },
  {
    path: '/company',
    name: 'company-list',
    meta: { title: '企业一览', icon: 'md-briefcase' },
    component: Main,
    children: [
      {
        path: '/company',
        name: 'company',
        meta: { icon: 'md-list', title: '企业列表', notCache: true },
        component: () => import('@/view/company/list')
      },
      {
        path: '/company/account-log',
        name: 'company-recharge',
        meta: { icon: 'md-list-box', title: '账户记录', notCache: true },
        component: () => import('@/view/company/account-log')
      },
      {
        path: '/company/recharge',
        name: 'company-recharge-legacy',
        meta: { hideInMenu: true, title: '充值记录', notCache: true },
        redirect: { name: 'company-recharge', query: { tab: 'recharge' } }
      },
      {
        path: '/company/money-clear-log',
        name: 'company-money-clear-log',
        meta: { hideInMenu: true, title: '清零记录', notCache: true, access: ['1'] },
        redirect: { name: 'company-recharge', query: { tab: 'clear' } }
      },
      {
        path: '/company-add',
        name: 'company-add',
        meta: { hideInMenu: true, title: '企业新增', icon: 'md-briefcase' },
        component: () => import('@/view/company/update')
      },
      {
        path: '/company-edit/:id',
        name: 'company-edit',
        meta: { hideInMenu: true, title: '企业编辑', icon: 'md-briefcase' },
        component: () => import('@/view/company/update')
      }
    ]
  },
  {
    path: '/agent',
    name: 'agent',
    meta: { access: ['0'], title: '合作伙伴', hide: false },
    component: Main,
    children: [
      {
        path: '/agent',
        name: 'agent',
        meta: { icon: 'md-people', title: '合作伙伴', notCache: true },
        component: () => import('@/view/agent/list')
      },
      {
        path: '/agent-add',
        name: 'agent-add',
        meta: { hideInMenu: true, title: '新增合作伙伴', notCache: true },
        component: () => import('@/view/agent/edit')
      },
      {
        path: '/agent-edit/:id',
        name: 'agent-edit',
        meta: { hideInMenu: true, title: '编辑合作伙伴', notCache: true },
        component: () => import('@/view/agent/edit')
      }
    ]
  },
  {
    path: '/increments',
    name: '_increments',
    meta: { icon: 'md-albums', notCache: true, title: '应用中心' },
    component: Main,
    children: [
      {
        path: '/increment',
        name: 'increment',
        meta: { icon: 'md-apps', title: '应用购买', notCache: true },
        component: () => import('@/view/increment')
      },
      {
        path: '/increments',
        name: 'increments',
        meta: { icon: 'md-appstore', title: '应用订单', notCache: true },
        component: () => import('@/view/increment/list')
      },
      {
        path: '/my_code',
        name: 'my_code',
        meta: { icon: 'md-barcode', title: '运维安全码', notCache: true, access: ['1'], hideInMenu: true },
        component: () => import('@/view/increment/my_code')
      },
      {
        path: '/local/index',
        name: 'local_index',
        meta: { icon: 'md-barcode', title: '授权管理', notCache: true, access: ['1'] },
        component: () => import('@/view/local/index')
      },
      {
        path: '/local/active-code',
        name: 'active-code',
        meta: { icon: 'md-barcode', title: '本地服务版', notCache: true, hideInMenu: true },
        component: () => import('@/view/local/active-code')
      }

    ]
  },
  {
    path: '/dispense',
    name: '_dispense',
    meta: { title: '财务管理', icon: 'logo-usd' },
    component: Main,
    children: [

      {
        path: '/dispense-merchant',
        name: 'dispense-merchant',
        meta: { icon: 'md-contacts', title: '收款人管理', notCache: true },
        component: () => import('@/view/dispense-merchant')
      },
      {
        path: '/payment/detail',
        name: 'payment-detail',
        meta: { icon: 'md-list', title: '分账详情', notCache: true },
        component: () => import('@/view/dispense-merchant/detail')
      },
      {
        path: '/wallet',
        name: 'wallet',
        meta: { icon: 'md-list', title: '钱包管理', notCache: true },
        component: () => import('@/view/dispense-merchant/wallet/wallet')
      },
      {
        path: '/payment/bind',
        name: 'payment-bind',
        meta: { icon: 'md-contacts', title: '批量绑定设备', notCache: true, hideInMenu: true },
        component: () => import('@/view/dispense-merchant/bind')
      },
      // {
      //   path: "/dispense-merchant-list",
      //   name: "dispense-merchant-list",
      //   meta: { icon: "md-contacts", title: "分账记录-商户", notCache: true },
      //   component: () => import("@/view/dispense-merchant/list")
      // },
      // 旧
      // {
      //   path: "/dispense",
      //   name: "dispense",
      //   meta: { icon: "md-contacts", title: "收款人", notCache: true },
      //   component: () => import("@/view/dispense")
      // },
      {
        path: '/dispense/list',
        name: 'dispense-list',
        meta: { icon: 'md-list', title: '分账记录(旧)', notCache: true },
        component: () => import('@/view/dispense/list')
      },
      // {
      //   path: "/dispense/detail",
      //   name: "dispense-detail",
      //   meta: { icon: "md-list", title: "分账明细", notCache: true },
      //   component: () => import("@/view/dispense/detail")
      // },
      {
        path: '/invoice',
        name: 'invoice',
        meta: { title: '发票受理', icon: 'md-albums' },
        component: () => import('@/view/invoice/list')
      },
      {
        path: '/capital-statistics',
        name: 'capital-statistics',
        meta: { title: '收益统计', icon: 'md-calculator', access: ['0'] },
        component: () => import('@/view/dispense/statistics')
      }
    ]
  },
  {
    path: '/payment/guide',
    name: 'payment-guide',
    meta: { title: '操作指引', notCache: true, hideInMenu: true },
    component: () => import('@/view/dispense-merchant/guide')
  },
  {
    path: '/increments/guide',
    name: 'increments-guide',
    meta: { icon: 'md-appstore', title: '收费标准', notCache: true, hideInMenu: true },
    component: () => import('@/view/increment/componse/guide')
  },
  {
    path: '/user',
    name: 'user',
    meta: { access: ['0'], title: '会员管理', icon: 'md-contact' },
    component: Main,
    children: [
      {
        path: '/user',
        name: 'user-list',
        meta: { title: '注册会员', icon: 'md-contact' },
        component: () => import('@/view/user/list')
      },
      {
        path: '/user-log',
        name: 'user-log',
        meta: { title: '钱包记录', icon: 'md-basket' },
        component: () => import('@/view/user-log/list')
      },
      {
        path: '/recharge-log',
        name: 'recharge-log',
        meta: { title: '充值记录', icon: 'logo-yen' },
        component: () => import('@/view/recharge-log')
      }
    ]
  },
  {
    path: '/amount',
    name: '_amount',
    meta: { title: '印量报表', icon: 'md-list-box' },
    component: Main,
    children: [
      {
        path: '/amount',
        name: 'amount',
        meta: { title: '消费统计', icon: 'md-calculator' },
        component: () => import('@/view/amount')
      },
      // {
      //   path: "/balance",
      //   name: "balance",
      //   meta: { title: "结算记录", icon: "md-reorder" },
      //   component: () => import("@/view/balance/list")
      // },
      {
        path: '/order',
        name: 'order',
        meta: { title: '订单管理', icon: 'md-document' },
        component: () => import('@/view/order/list')
      }
    ]
  },
  {
    path: '/tmall-after-sale',
    redirect: '/tmall-after-sale/appeal',
    name: '_tmall_after_sale',
    meta: {
      title: '天猫售后',
      icon: 'md-headset',
      accessCheck: tmallAfterSaleAccess
    },
    component: Main,
    children: [
      {
        path: '/tmall-after-sale/appeal',
        name: 'tmall-after-sale-appeal',
        meta: {
          title: '申诉管理',
          icon: 'md-list',
          notCache: true,
          accessCheck: tmallAfterSaleAccess
        },
        component: () => import('@/view/tmall-after-sale')
      },
      {
        path: '/tmall-after-sale/type',
        name: 'tmall-after-sale-type',
        meta: {
          title: '申诉类型',
          icon: 'md-pricetags',
          notCache: true,
          accessCheck: tmallAfterSaleAccess
        },
        component: () => import('@/view/tmall-after-sale/type')
      }
    ]
  },
  {
    path: '/meter-log',
    name: 'meter',
    meta: { title: '智能运维', icon: 'ios-list-box' },
    component: Main,
    children: [
      {
        path: '/fault',
        name: 'fault',
        meta: { title: '故障记录', icon: 'md-close-circle' },
        component: () => import('@/view/fault/list')
      },
      {
        path: '/meter-log',
        name: 'meter-log',
        meta: { title: '抄表记录', icon: 'md-information-circle' },
        component: () => import('@/view/meter-log/list')
      },
      {
        path: '/meter-charge',
        name: 'meter-charge',
        meta: { title: '抄表结算方案', icon: 'md-apps' },
        component: () => import('@/view/meter-charge/list')
      },
      {
        path: '/meter-charge-add',
        name: 'meter-charge-add',
        meta: { hideInMenu: true, title: '抄表结算方案新增', icon: 'md-apps' },
        component: () => import('@/view/meter-charge/edit')
      },
      {
        path: '/meter-charge-edit/:id',
        name: 'meter-charge-edit',
        meta: { hideInMenu: true, title: '抄表结算方案修改', icon: 'md-apps' },
        component: () => import('@/view/meter-charge/edit')
      },
      {
        path: '/meter-order',
        name: 'meter-order',
        meta: { title: '抄表结算单', icon: 'md-document' },
        component: () => import('@/view/meter-order/list')
      },
      {
        path: '/meter-qrcode',
        name: 'meter-qrcode',
        meta: { title: '抄表二维码', icon: 'md-document' },
        component: () => import('@/view/meter-qrcode/list')
      }, {
        path: '/meter-order-add',
        name: 'meter-order-add',
        meta: { hideInMenu: true, title: '抄表结算单生成', icon: 'md-document' },
        component: () => import('@/view/meter-order/list/insert')
      }
    ]
  },
  {
    path: '/system-setting',
    name: 'system-setting',
    meta: { title: '系统设置', icon: 'ios-cog' },
    component: Main,
    children: [
      {
        path: '/delivery/fee',
        component: () => import('@/view/delivery/DeliveryFeeList'),
        name: 'DeliveryFee',
        meta: { hideInMenu: true, title: '配送费设置', icon: 'md-information-circle' }
      },
      {
        path: '/notice',
        name: 'notice',
        meta: { title: '推送设置', icon: 'md-information-circle' },
        component: () => import('@/view/notice/index')
      },
      {
        path: '/role',
        name: 'role',
        meta: { title: '角色管理', icon: 'md-information-circle' },
        component: () => import('@/view/role/role/index')
      },
      {
        path: '/admin_user',
        name: 'admin_user',
        meta: { title: '账号管理', icon: 'md-information-circle' },
        component: () => import('@/view/role/user/index')
      },
      {
        path: '/setting/machine-activity-agent',
        name: 'machine-activity-agent',
        meta: { title: '消费限免', icon: 'md-print', access: ['1'] },
        component: () => import('@/view/machine-activity')
      },
      {
        path: '/machine/discount',
        name: 'discount',
        meta: { title: '消费折扣', icon: 'md-cash', access: ['1'] },
        component: () => import('@/view/discount')
      },
      {
        path: '/update-notice',
        name: 'update-notice',
        meta: { title: '产品更新公告', hideInMenu: true },
        component: () => import('@/view/update-notice')
      },
      {
        path: '/notice-list',
        name: 'notice-list',
        meta: { title: '通知中心', icon: 'md-information-circle', access: ['1'] },
        // meta: { title: "通知中心", icon: "md-information-circle", access: ["0"]  },
        component: () => import('@/view/setting/notice/list')
      },
      {
        path: '/notice/info',
        name: 'notice-info',
        meta: { title: '通知中心', hideInMenu: true },
        component: () => import('@/view/setting/notice/list/info')
      },
      {
        path: '/notice-manage',
        name: 'notice-manage',
        meta: { title: '通知中心', icon: 'md-information-circle', access: ['0'] },
        component: () => import('@/view/setting/notice/manage')
      },
      {
        path: '/notice/edit',
        name: 'notice-edit',
        meta: { title: '通知中心', hideInMenu: true },
        component: () => import('@/view/setting/notice/manage/edit')
      }
      /* {
        path: "/notice/agent",
        name: "notice_agent",
        meta: { title: "推送（合作伙伴）", icon: "md-information-circle" },
        component: () => import("@/view/notice/agent")
      },
      {
        path: "/notice/company",
        name: "notice_company",
        meta: { title: "推送（企业管理员）", icon: "md-information-circle" },
        component: () => import("@/view/notice/company")
      },
      {
        path: "/notice/repair",
        name: "notice_repair",
        meta: { title: "推送（维护人员）", icon: "md-information-circle" },
        component: () => import("@/view/notice/repair")
      }, */

    ]
  },
  {
    path: '/setting',
    name: 'setting',
    meta: { title: '平台设置', icon: 'md-settings', access: ['0'] },
    component: Main,
    children: [
      {
        path: '/setting/machine-activity',
        name: 'machine-activity',
        meta: { title: '消费限免', icon: 'md-print', access: ['0'] },
        component: () => import('@/view/machine-activity')
      },
      {
        path: '/machine/discount1',
        name: 'discount1',
        meta: { title: '消费折扣', icon: 'md-cash', access: ['0'] },
        component: () => import('@/view/discount')
      },
      {
        path: '/setting/coupon',
        name: 'coupon',
        meta: { title: '优惠券', icon: 'md-cash', access: ['0'] },
        component: () => import('@/view/coupon')
      },
      {
        path: '/setting/set',
        name: 'set',
        meta: { title: '设置', icon: 'md-settings', access: ['0'] },
        component: () => import('@/view/setting')
      },
      {
        path: '/setting/banner',
        name: 'banner',
        meta: { title: 'banner管理', icon: 'md-settings', access: ['0'] },
        component: () => import('@/view/setting/banner')
      },
      {
        path: '/setting/recharge/activity',
        name: 'recharge-activity',
        meta: { title: '充值活动', icon: 'ios-bookmark', access: ['0'] },
        component: () => import('@/view/recharge-activity')
      },
      {
        path: '/setting/screen-saver',
        name: 'screen-saver',
        meta: { title: '设备屏保', icon: 'md-laptop', access: ['0'] },
        component: () => import('@/view/screen-saver')
      },
      {
        path: '/setting/screen-saver/bind',
        name: 'screen-saver-bind',
        meta: { hideInMenu: true, title: '设备屏保', icon: 'md-laptop', access: ['0'] },
        component: () => import('@/view/screen-saver/bind')
      },
      {
        path: '/setting/screen-saver/edit/:id',
        name: 'screen-saver-edit',
        meta: { hideInMenu: true, title: '设备屏保', icon: 'md-laptop', access: ['0'] },
        component: () => import('@/view/screen-saver/edit.vue')
      },
      {
        path: '/setting/code',
        name: 'code',
        meta: { title: '安全码管理', icon: 'md-american-football', access: ['0'] },
        component: () => import('@/view/code')
      },
      {
        path: '/setting/safety-code',
        name: 'safety-code',
        meta: { title: '本地安全码', icon: 'md-american-football', access: ['0'] },
        component: () => import('@/view/safety-code')
      },
      {
        path: '/setting/log',
        name: 'log',
        meta: { title: '设备日志', icon: 'ios-paper', access: ['0'] },
        component: () => import('@/view/setting/log')
      },
      {
        path: '/setting/file-server',
        name: 'file-server',
        meta: { title: '文件服务器管理', icon: 'md-cloud-circle', access: ['0'] },
        component: () => import('@/view/setting/file-server')
      },
      {
        path: '/setting/update',
        name: 'update',
        meta: { title: '远程更新', icon: 'md-cloud-upload', access: ['0'] },
        component: () => import('@/view/setting/update')
      },
      {
        path: '/setting/update/edit',
        name: 'update-edit',
        meta: { title: '远程更新/新增', icon: 'md-cloud-upload', hideInMenu: true, access: ['0'] },
        component: () => import('@/view/setting/update/edit')
      }
    ]
  },
  {
    path: '/web',
    name: 'web',
    meta: { title: '官网设置', icon: 'md-speedometer', access: ['0'] },
    component: Main,
    children: [
      {
        path: '/web/case/list',
        name: 'case',
        meta: { title: '案例管理', icon: 'md-bookmarks' },
        component: () => import('@/view/web/case/list')
      },

      {
        path: '/web/case/edit',
        name: 'case-edit',
        meta: { title: '案例编辑/新增', icon: 'md-create', hideInMenu: true },
        component: () => import('@/view/web/case/edit')
      },
      {
        path: '/help/list',
        name: 'help',
        meta: { title: '帮助中心', icon: 'md-bookmarks' },
        component: () => import('@/view/help/index')
      },
      {
        path: '/help/edit',
        name: 'help',
        meta: { title: '帮助中心', icon: 'md-bookmarks', hideInMenu: true },
        component: () => import('@/view/help/edit')
      }
    ]
  },
  // {
  //   path: "/info",
  //   name: "info",
  //   meta: { hide: true },
  //   component: Main,
  //   children: [
  //     {
  //       path: "/info",
  //       name: "info",
  //       meta: { icon: "md-chatboxes", title: "信息发布", notCache: true },
  //       component: () => import("@/view/info/list")
  //     }
  //   ]
  // },
  {
    path: '/download',
    name: '_download',
    meta: { title: '下载中心' },
    component: Main,
    children: [
      {
        path: '/download',
        name: 'download',
        meta: { icon: 'md-arrow-down', title: '资料下载', notCache: true },
        component: () => import('@/view/download/list')
      }
    ]
  },

  {
    path: '/login',
    name: 'login',
    meta: { title: 'Login - 登录', hideInMenu: true },
    component: () => import('@/view/login/login.vue')
  },

  {
    path: '/dashboard',
    name: 'dashboard',
    meta: { hideInMenu: true },
    component: () => import('@/view/dashboard/index')
  },
  // 401
  {
    path: '/401',
    name: 'error_401',
    meta: { hideInMenu: true },
    component: () => import('@/view/error-page/401.vue')
  },
  {
    path: '/meter-qrcode-print',
    name: 'meter-qrcode-print',
    meta: { hideInMenu: true },
    component: () => import('@/view/meter-qrcode/list/print')
  }
]
